<template>
    <BaseLayout>
        <div class="container py-5">
            <div class="col-lg-5 col-md-7 mx-auto">
                <div class="shadow rounded-4 p-lg-5 p-3">
                    <div class="text-center mb-4">
                        <h1 class="ff-dsb fs-36 text-primary">Forgot Password</h1>
                        <p class="fs-20">Insert your email address and we will email you a password reset link that will allow you to choose a new one.</p>
                    </div>
                    <form @submit.prevent="submit" class="vstack gap-4">
                        <div v-if="honeypot.enabled" :name="`${honeypot.nameFieldName}_wrap`" style="display:none;">
                            <input type="text" v-model="forgotPasswordForm.nameFieldName" :name="honeypot.nameFieldName" />
                            <input type="text" v-model="forgotPasswordForm.validFromFieldName" :name="honeypot.validFromFieldName" />
                        </div>
                        <div>
                            <label for="inputEmail" class="form-label">Email</label>
                            <input id="inputEmail" type="email" inputmode="email" v-model="forgotPasswordForm.email" class="form-control" :class="errors.email ? 'is-invalid':''" placeholder="mail@example.com" value="" required autofocus>
                            <div v-if="errors.email" class="invalid-feedback">
                                {{ errors.email }}
                            </div>
                        </div>

                        <div class="text-center">
                            <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit" :disabled="forgotPasswordForm.processing">
                                Email Password Reset Link <i v-if="forgotPasswordForm.processing" class="fad fa-spinner-third fa-spin"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useForm } from '@inertiajs/vue3';
import BaseLayout from '../../../../../../../resources/js/front/Layouts/BaseLayout.vue';

const props = defineProps({ errors : Object, honeypot: Object })
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

const forgotPasswordForm = useForm({
    email: null,
    g_recaptcha_response: null,
    nameFieldName: '',
    validFromFieldName: props.honeypot.encryptedValidFrom,
})

async function submit() {
    await recaptchaLoaded()
    forgotPasswordForm.g_recaptcha_response = await executeRecaptcha('forgot')
    forgotPasswordForm.post(route('user.password.email'))
}
</script>